import './briefe.css';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useClientApp } from '../context';
import { dokumentePath } from '../dokumente/labels';
import { briefePath, senderOfSlug } from './labels';
import { FirmPage, FolderPage, LetterSheetHost } from './Pages';
import { UploadSheetHost } from './Upload';

// Ordner Briefe unter „Dokumente“ (siehe dokumente/DokumenteRoutes.tsx): Briefe der Firma → Briefe eines Absenders.
// Prüft die Teile der Adresse und zeigt die passende Seite.
export function BriefeLevel({ folder }: { folder?: boolean }) {
  const { clients, clientName } = useClientApp();
  const p = useParams();
  const clientId = p.clientId ?? '';
  if (!clients.some((c) => c.id === clientId)) return <Navigate to={dokumentePath()} replace />;
  if (folder) {
    const sender = senderOfSlug(p.sender);
    if (!sender) return <Navigate to={briefePath(clientId)} replace />;
    return (
      <>
        <FolderPage clientId={clientId} sender={sender} />
        <LetterSheetHost />
      </>
    );
  }
  return (
    <>
      <FirmPage clientId={clientId} />
      <LetterSheetHost />
      <UploadSheetHost clientId={clientId} clientName={clientName(clientId)} />
    </>
  );
}

// Frühere Adressen /app/briefe/<Firma>/<Absender> (Links in alten Meldungen, Lesezeichen) führen in den Ordner Briefe
export function OldBriefeRedirect() {
  const loc = useLocation();
  const [clientId, sender] = loc.pathname.replace(/^\/app\/briefe\/?/, '').split('/');
  const to = clientId ? `${dokumentePath(clientId)}/briefe${sender ? `/${sender}` : ''}` : dokumentePath();
  return <Navigate to={{ pathname: to, search: loc.search }} state={loc.state} replace />;
}
